var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504 80C508.406 80 512 76.422 512 72S508.406 64 504 64H384C381.375 64 378.938 65.281 377.438 67.438L123.812 432H8C3.594 432 0 435.578 0 440S3.594 448 8 448H128C130.625 448 133.062 446.719 134.562 444.562L388.188 80H504ZM504 432H328C323.582 432 320 435.582 320 440S323.582 448 328 448H504C508.418 448 512 444.418 512 440S508.418 432 504 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlt);
export default __webpack_public_path__ + "static/media/alt.1b8781af98f16221f1c92a07044f825a.svg";
export { ForwardRef as ReactComponent };